import { FC } from 'react';
import ExecutiveSummaryContainer from '../../../executive-summary/containers/ExecutiveSummaryContainer';
import ExecutiveSummaryPageAvatarContainer from '../../../executive-summary/containers/ExecutiveSummaryPageAvatarContainer';
import ScrollablePage from '../ScrollablePage';

const ExecutiveSummaryPage: FC = () => {
  return (
    <ScrollablePage>
      <ExecutiveSummaryPageAvatarContainer>
        <ExecutiveSummaryContainer />
      </ExecutiveSummaryPageAvatarContainer>
    </ScrollablePage>
  );
};

export default ExecutiveSummaryPage;
